module.exports = __webpack_public_path__ + "38da20d5f7911ae8a7f22b1a56ce2ea1.svg";